module.exports = __webpack_public_path__ + "img/TerrieChan.e167faa9.jpg";